import React from 'react';
export function MaterialsTagsPanel() {
  return <div className="w-48 shrink-0" data-id="element-853">
      <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-854">
        Filter by
      </h4>
      {/* Category filters */}
      <div className="mb-4" data-id="element-855">
        <h5 className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1" data-id="element-856">
          Category
        </h5>
        <div className="space-y-1" data-id="element-857">
          {['Wood', 'Glass', 'Stone', 'Fabric', 'Metal', 'Tile', 'Plastic'].map(category => <div key={category} className="flex items-center" data-id="element-858">
                <input id={`category-${category}`} type="checkbox" className="w-3 h-3 text-blue-600 rounded border-gray-300 focus:ring-blue-500 dark:bg-darkbg-primary dark:border-darkbg-border" data-id="element-859" />
                <label htmlFor={`category-${category}`} className="ml-2 text-xs text-gray-700 dark:text-gray-300" data-id="element-860">
                  {category}
                </label>
              </div>)}
        </div>
      </div>
      {/* Property filters */}
      <div className="mb-4" data-id="element-861">
        <h5 className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1" data-id="element-862">
          Property
        </h5>
        <div className="space-y-1" data-id="element-863">
          {['Natural', 'Transparent', 'Soft', 'Industrial', 'Brushed', 'Ceramic'].map(property => <div key={property} className="flex items-center" data-id="element-864">
              <input id={`property-${property}`} type="checkbox" className="w-3 h-3 text-blue-600 rounded border-gray-300 focus:ring-blue-500 dark:bg-darkbg-primary dark:border-darkbg-border" data-id="element-865" />
              <label htmlFor={`property-${property}`} className="ml-2 text-xs text-gray-700 dark:text-gray-300" data-id="element-866">
                {property}
              </label>
            </div>)}
        </div>
      </div>
    </div>;
}